export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#8B4513] to-[#A0522D] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Logo and Description */}
          <div className="md:col-span-2 text-center md:text-left">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-4 mb-4 md:mb-6">
              <img 
                src="https://static.readdy.ai/image/7952c1edd780462186458d18cb4f26e0/c6f1d5166ee85a0e65936426d673604b.jpeg" 
                alt="Las Cruces Injury - Personal Injury Attorney" 
                title="Las Cruces Injury - Personal Injury Attorney"
                className="h-28 md:h-36 w-auto"
              />
              <div className="flex items-center gap-3">
                <a 
                  href="https://www.facebook.com/people/Las-Cruces-Injury/61586799041875/?mibextid=wwXIfr&rdid=QbvgJZHeH9nTpDfs&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1F8xxLvDJV%2F%3Fmibextid%3DwwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-[#1877F2] hover:bg-[#0C63D4] transition-colors cursor-pointer"
                  aria-label="Visit our Facebook page"
                >
                  <i className="ri-facebook-fill text-2xl md:text-3xl text-white"></i>
                </a>
                <a 
                  href="https://www.instagram.com/lascrucesinjury1?igsh=MXZuc3l6MWlkcXV3Zw%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F56040] hover:opacity-90 transition-opacity cursor-pointer"
                  aria-label="Visit our Instagram page"
                >
                  <i className="ri-instagram-fill text-2xl md:text-3xl text-white"></i>
                </a>
              </div>
            </div>
            <p className="text-white/90 mb-4 leading-relaxed text-sm md:text-base">
              Dedicated to fighting for justice and maximum compensation for personal injury victims in Las Cruces and throughout New Mexico.
            </p>
            <div className="flex items-center gap-2 text-white/90 mb-2 justify-center md:justify-start">
              <i className="ri-translate-2 w-5 h-5 flex items-center justify-center"></i>
              <span className="font-semibold text-sm md:text-base">Se Habla Español</span>
            </div>
            <p className="text-xs md:text-sm text-white/80">Servicio legal en español disponible</p>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="text-base md:text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="#about" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h4 className="text-base md:text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start gap-3 justify-center md:justify-start">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                <div>
                  <a href="tel:575-567-7668" className="text-white/90 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    575-567-7668
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3 justify-center md:justify-start">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                <a href="mailto:info@lascrucesinjury.com" className="text-white/90 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                  info@lascrucesinjury.com
                </a>
              </li>
              <li className="flex items-start gap-3 justify-center md:justify-start">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                <span className="text-white/90 text-sm md:text-base">
                  Las Cruces, New Mexico
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA Section */}
        <div className="border-t border-white/20 pt-6 md:pt-8 mb-6 md:mb-8">
          <div className="text-center">
            <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">Ready to Get Started?</h3>
            <p className="text-white/90 mb-4 md:mb-6 text-sm md:text-base">Contact us today for your free consultation</p>
            <a 
              href="#contact" 
              className="inline-block bg-green-600 text-white px-6 py-3 md:px-8 md:py-3 rounded-full font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base"
            >
              Free Consultation • Consulta Gratis
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-xs md:text-sm text-center md:text-left">
            © 2026 Las Cruces Personal Injury. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">
              Website Builder
            </a>
            <a href="#" className="text-white/70 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-white/70 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
